import { useEffect, useCallback } from 'react';

/**
 * Triggers a need to refresh based on an interval or tab becoming visible
 * @param {object} options
 * @param {fn} options.refresh A callback function. Use it to refresh if a refresh is warranted based on app state
 * @param {number} options.periodicRefreshInterval Time in ms to trigger refresh periodically
 */
const useRefresh = ({
  refresh,
  periodicRefreshInterval,
}) => {
  // Check for updates periodically
  useEffect(() => {
    const intervalId = setInterval(() => {
      refresh();
    }, periodicRefreshInterval);
    return () => {
      clearInterval(intervalId);
    };
  }, [periodicRefreshInterval, refresh]);

  const handleVisibilityChange = useCallback(() => {
    if (document.visibilityState === 'visible') {
      refresh();
    }
  }, [refresh]);

  // Check for updates on tab active
  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleVisibilityChange]);
};

export default useRefresh;
